import { render, staticRenderFns } from "./WarningModal.vue?vue&type=template&id=3bc5f6da"
import script from "./WarningModal.vue?vue&type=script&lang=ts"
export * from "./WarningModal.vue?vue&type=script&lang=ts"
import style0 from "./WarningModal.vue?vue&type=style&index=0&id=3bc5f6da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports